import { z } from "zod";

const stripeLimitsSchema = z.object({
  users: z.number(),
});

export type StripeLimits = z.infer<typeof stripeLimitsSchema>;
